import styled from 'styled-components';

// ─── Page Container ───────────────────────────────────────────────────────────
// Shared by: JobsLibraryV2, SkillsBridgerV2

export const PageContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${p => p.theme?.colors?.cardBg ?? p.theme?.colors?.white ?? '#ffffff'};
  border-radius: 10px;
  border: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
  box-shadow: 0 2px 12px rgba(16, 24, 64, 0.08);
`;

// ─── Page Header ─────────────────────────────────────────────────────────────
// Shared by: JobsLibraryV2, SkillsBridgerV2

export const PageHeaderStyled = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid ${p => p.theme?.colors?.border ?? '#D8DAE5'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: ${p => p.theme?.colors?.cardBg ?? p.theme?.colors?.white ?? '#ffffff'};
  position: relative;
  z-index: var(--z-header, 1000);
  > div { flex: 1; }
  > div:first-child { flex: 3; }
  > div:last-child { flex: 2; }
`;

// ─── Header Left / Right ──────────────────────────────────────────────────────
// Shared by: JobsLibraryV2, SkillsBridgerV2

export const HeaderLeftStyled = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HeaderRightStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 16px;
`;

// ─── Heading Row ──────────────────────────────────────────────────────────────
// Shared by: JobsLibraryV2, SkillsBridgerV2

export const HeadingRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  .ant-typography {
    margin: 0;
  }
`;

// ─── Table Scroll Wrapper ─────────────────────────────────────────────────────
// Fills remaining vertical space; the only scrollable area.
// Shared by: JobsLibraryV2, SkillsBridgerV2

export const TableWrapperStyled = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
`;

// ─── Page Table Wrapper (base) ────────────────────────────────────────────────
// Owns sticky pagination and the paic-pagination-total styles shared by all tables.
// Extend this in module-specific files to add row-state overrides.
// Shared by: JobsLibraryV2 (extended), SkillsBridgerV2 (used directly)

export const PageTableWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  /* ── Table surface follows the card color (cardBg) ── */
  .ant-table {
    background: transparent;
  }
  .ant-table-tbody > tr > td {
    background: transparent;
  }

  /* ── Sticky pagination ── */
  .ant-table-pagination {
    position: sticky;
    bottom: 0;
    background: ${p => p.theme?.colors?.cardBg ?? p.theme?.colors?.white ?? '#ffffff'};
    padding: 12px 16px;
    margin: 0 !important;
    border-top: 1px solid ${p => p.theme?.colors?.borderLight ?? '#E5E7EB'};
    justify-content: space-between;
  }

  .ant-pagination-total-text {
    margin-right: auto;
  }

  /* ── Filter total row ── */
  .paic-pagination-total {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .paic-pagination-total .is-active-text {
    color: ${p => p.theme?.colors?.primary ?? '#008080'};
    font-weight: 500;
  }

  .paic-pagination-total .is-empty-text {
    color: ${p => p.theme?.colors?.textSecondary ?? '#8c8c8c'};
  }
`;

// ─── Action Buttons Row ───────────────────────────────────────────────────────
// Apply className="action-btn" to SbButton for fixed equal width.
// Shared by: JobsLibraryV2, SkillsBridgerV2

export const ActionRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .action-btn {
    min-width: 190px;
  }
`;
